export default __webpack_public_path__ + "static/media/golden-reels.0d63c937.webp";